import {Options} from '@fl/cmsch-fe-library';
import {none, Opt} from 'ts-opt';

import {AnalysisProtocol} from 'api/gen/AnalysisProtocol';
import {ApcStableDate} from 'api/gen/ApcStableDate';
import {CorrectionReportDetail} from 'api/gen/CorrectionReportDetail';
import {PagedModelCorrectionReport} from 'api/gen/PagedModelCorrectionReport';

import {AnalysisProtocolCorrectionLoadingId} from '../types/analysis-protocol-correction-loading-id';

/** Redux state stored for the analysis protocol correction module. */
export interface AnalysisProtocolCorrectionState {
    /** Paginated APC overview rows for the connected table. */
    pageAnalysisProtocolCorrectionReports: Opt<PagedModelCorrectionReport>;
    /** Active loading-state identifiers for APC async workflows. */
    loading: Array<AnalysisProtocolCorrectionLoadingId>;
    /** Stable/date relations loaded for the current ear tag and correction mode. */
    apcStableDate: Opt<ApcStableDate>;
    /** Select options available for the proficiency test date field. */
    proficiencyTestDateOptions: Opt<Options<string>>;
    /** Select options available for the stable field. */
    stableOptions: Opt<Options<string>>;
    /** Reports created during the current create/edit session. */
    createdCorrectionReports: Array<CorrectionReportDetail>;
    /** Currently edited correction report id, when editing an existing record. */
    editingCorrectionReportId?: number;
    /** Loaded protocol data used to prefill dependent APC form fields. */
    analysisProtocol: Opt<AnalysisProtocol>;
}

/** Default analysis protocol correction state snapshot. */
export const initialAnalysisProtocolCorrectionState: AnalysisProtocolCorrectionState = {
    pageAnalysisProtocolCorrectionReports: none,
    loading: [],
    apcStableDate: none,
    proficiencyTestDateOptions: none,
    stableOptions: none,
    createdCorrectionReports: [],
    editingCorrectionReportId: undefined,
    analysisProtocol: none,
};
